import {emptyScene} from "./sceneModel";

export function parseSceneFromSvg(svgString) {
    const fallback = emptyScene();
    if (!svgString || typeof svgString !== "string") return fallback;
    const m = svgString.match(/<metadata>\s*<!\[CDATA\[([\s\S]*?)]]>\s*<\/metadata>/);
    if (!m) return fallback;
    try {
        // No reverse-transform needed: serializeScene encodes < and > as
        // standard JSON </> escapes, which JSON.parse decodes
        // back to the original characters on its own.
        const scene = JSON.parse(m[1]);
        const result = {
            viewBox: scene.viewBox || fallback.viewBox,
            shapes: Array.isArray(scene.shapes) ? scene.shapes : [],
            markers: Array.isArray(scene.markers) ? scene.markers : [],
        };
        // background přidáme jen když existuje, aby round-trip scény bez podkladu
        // zůstal přesně {viewBox, shapes, markers} (viz test bez podkladu).
        if (scene.background) result.background = scene.background;
        // popisky se ukládají jen když jsou vypnuté (default = zobrazit)
        if (scene.labels === false) result.labels = false;
        return result;
    } catch (e) {
        return fallback;
    }
}
